import type { FaireProductEntity } from "../../entity_types/product";

export const p_zd34cmnatn: FaireProductEntity = {
  token: "p_zd34cmnatn",
  type: "product",
  name: "Aches and Pains Muscle Ache and Pain Relief Magnesium Spray",
  brandToken: "b_8i6qzemm69",
  brandName: "Roots To Remedies",
  imageUrl: "https://cdn.faire.com/fastly/c839f8ad60a33e7629185f9ed681b906bebf30c8d8570977c9f8d12af077d199.png",
  galleryImageUrls: [],
  priceDollars: 9.5,
  description: "Are you sore from a work out or carrying your LO on your hip? Did you sleep wrong or just in general pain from sitting all day at work? This blend of herbs and magnesium would be very helpful in bringing you some relief!\n\n \n\n**These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.\n\nIngredients:\nMagnesium Chloride Flakes, St. John's Wort (Hypericum perforatum)*, Arnica (Arnica montana)*, Valerian Root (Valeriana wallichii)*, Chamomile Flowers (Matricaria recutita)*, Witch Hazel *, Cane Derived Alcohol, Filtered Water, Lavender EO*, Juniper Berry EO *\n\n* Certified Organic Ingredient",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:13.711Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
